<div class="toast-container position-fixed top-0 end-0 p-3">
  <div
    #toastRef
    class="toast align-items-center border-0"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
    [ngClass]="toastClasses"
  >
    <div class="toast-header">
      <img src="assets/img/efb.svg" width="25" class="rounded me-2" alt="logo" />
      <strong class="me-auto">Notification</strong>
      <small>maintenant</small>
      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    <div class="toast-body">
      {{ toastAlert?.message }}
    </div>
  </div>
</div>
